<div class="background-replacement" (click)="turnConfirmOn()"></div>
